import '../../css/mk-brand.css';
import {useEffect, useState} from "react";
import {gPageView} from "../../google-analytics";
import GameClient from "../../lib/game-client";
import SuperOgPanels from "../../constants/super-og-panels";
import {ReactFloatingBalloons} from "react-floating-balloons";

function GameResultsPanel({onChangePanel, data, game, playerPK}) {
    useEffect(() => {
        gPageView('super-og-game-result');
    },);

    function getStars(numStars) {
        let stars = [];
        for (let i = 0; i < numStars; i++) {
            stars.push(<i className="fa-solid fa-star"></i>);
        }
        return <span>{stars}</span>;
    }

    function getDetails(gameType, isChamp, chef, game) {
        let details = 'Details:';
        switch (gameType) {
            case GameClient.gameTypes().Rarity:
                details = 'Rarity Rank:' + game[`${isChamp ? 'champRarityRating' : 'challengerRarityRating'}`];
                break;
            case GameClient.gameTypes().Traits:
                details = game[`${isChamp ? 'champTrait' : 'challengerTrait'}`] + ': ' + game[`${isChamp ? 'champTraitRarity' : 'challengerTraitRarity'}`] + '%';
                break;
            default:
            case GameClient.gameTypes().OGist:
                const isoMintDateString = game[`${isChamp ? 'champOGDate' : 'challengerOGDate'}`];
                const options = {
                    year: 'numeric', month: 'short', day: 'numeric',
                    hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short',
                };
                const isoMintDate = new Date(isoMintDateString);
                const formatter = new Intl.DateTimeFormat('default', options);
                details = formatter.format(isoMintDate);
                break;
        }
        return <div className="w-40 max-h-38 rounded-lg">
            {details}
        </div>;
    }

    return (
        <div id="super-og-set" className="m-2">
            <div className="container bg-zinc-800 pt-4 px-4 md:px-32 pb-4 rounded-lg max-w-4xl">
                <div className="flex flex-row">
                    <div className="max-w-2xl mx-auto mb-10 space-y-2">
                        <div className="flex-row">
                            <div className="flex text-6xl mb-1">
                                <div className="text-brand font-extrabold">Super</div>
                                <div className="font-extrabold">OG</div>
                            </div>
                            <div className="text-brand-text text-2xl pull-right cursor-pointer hover:font-bold">
                                <a href="https://metakitchen.gitbook.io/metakitchen-wp/wb1pN4vYLKsa8w4IX5qL/the-menu/game-mechanics/ready-set-whip">
                                    Game Result
                                </a>
                            </div>
                            <button className="text-brand-text bg-brand font-bold rounded-lg p-2 m-1"
                                    onClick={async () => {
                                        await onChangePanel(SuperOgPanels.Lobby);
                                    }}>Back to Lobby
                            </button>
                            <div className="border border-brand mb-2"/>
                            <div className="flex justify-between mx-auto space-x-4">
                                <div className="space-y-1 w-full">
                                    <div className="flex my-auto space-x-1">
                                        <span className="my-auto">Handle:</span>
                                        <div className="bg-zinc-400 p-2 w-full rounded-lg">{game.handle}</div>
                                    </div>
                                    <div className="flex  my-auto space-x-1">
                                        <span className="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pot:&nbsp;</span>
                                        <div className="p-1 w-full rounded-lg text-brand-text bg-zinc-400 pl-5 w-32">
                                            {game.amount + ' ' + (game.isSOL ? '$SOL' : '$CHEF')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="border border-brand mt-2"/>
                        </div>
                        <h1 className="mb-6 mt-6 text-white md:text-2xl">
                            After three rounds of <span className="text-brand font-extrabold">Super</span><span
                            className="font-extrabold">OG</span> battle
                        </h1>
                        <div className="bg-brand-hover p-2 rounded-lg space-y-1">
                            <div className="flex justify-center space-x-2">
                                {
                                    game?.turns.map(turn => {
                                        return <div
                                            className="px-8 text-center w-44 max-h-38 rounded-lg bg-zinc-500">{GameClient.getGameName(turn.gameType)}</div>;
                                    })
                                }
                            </div>
                            <div className="flex justify-center space-x-2">
                                {
                                    game?.turns.map(turn => {
                                        return <div
                                            className="px-8 font-bold text-sm text-center w-44 max-h-38 rounded-lg bg-zinc-500">{turn.isChallengeSuccessful ? 'Challenger' : 'Champion'}
                                            <span className="text-xs">&nbsp;wins</span></div>;
                                    })
                                }
                            </div>
                        </div>
                        <div className="bg-brand-hover p-2 rounded-lg">
                            <div className="text-center font-bold">{(playerPK === game.champWalletPK) ? 'You' :  'Opponent'}</div>
                            <div id="player1Chefs" className="md:flex justify-center md:space-x-2 space-y-1">
                                <div id="firstChef"
                                     className={`flex flex-col text-center p-2 ${game?.turns[0].isChallengeSuccessful ? 'bg-zinc-400' : 'bg-amber-300 animate-pulse'} rounded-lg`}>
                                    {game?.turns[0]?.champion ? getStars(game?.turns[0].champion.stars) : null}
                                    {game?.turns[0]?.champion ?
                                        <img className="w-40 max-h-38 rounded-lg" src={game?.turns[0]?.champion.image}/>
                                        :
                                        <div
                                            className="fa-solid fa-upload text-brand text-6xl w-40 max-h-40 bg-zinc-200 rounded-lg py-12"/>
                                    }
                                    {getDetails(game?.turns[0]?.gameType, true, game?.turns[0]?.champion, game)}
                                </div>
                                <div id="secondChef"
                                     className={`flex flex-col text-center p-2 ${game?.turns[1].isChallengeSuccessful ? 'bg-zinc-400' : 'bg-amber-300 animate-pulse'} rounded-lg`}>
                                    {game?.turns[1]?.champion ? getStars(game?.turns[1]?.champion.stars) : null}
                                    {game?.turns[1]?.champion ?
                                        <img className="w-40 max-h-38 rounded-lg" src={game?.turns[1]?.champion.image}/>
                                        :
                                        <div
                                            className="fa-solid fa-upload text-brand text-6xl w-40 max-h-40 bg-zinc-200 rounded-lg py-12"/>
                                    }
                                    {getDetails(game?.turns[1]?.gameType, true, game?.turns[0]?.champion, game)}
                                </div>
                                <div id="thirdChef"
                                     className={`flex flex-col text-center p-2 ${game?.turns[2].isChallengeSuccessful ? 'bg-zinc-400' : 'bg-amber-300 animate-pulse'} rounded-lg`}>
                                    {game?.turns[2]?.champion ? getStars(game?.turns[2]?.champion.stars) : null}
                                    {game?.turns[2]?.champion ?
                                        <img className="w-40 max-h-38 rounded-lg" src={game?.turns[2]?.champion.image}/>
                                        :
                                        <div
                                            className="fa-solid fa-upload text-brand text-6xl w-40 max-h-40 bg-zinc-200 rounded-lg py-12"/>
                                    }
                                    {getDetails(game?.turns[2]?.gameType, true, game?.turns[2]?.champion, game)}
                                </div>
                            </div>
                        </div>
                        <div className="bg-brand-hover p-2 rounded-lg">
                            <div className="text-center font-bold">{playerPK === game.challengerWalletPK ? 'You' :  'Opponent'}</div>
                            <div id="player2Chefs" className="md:flex justify-center md:space-x-2 space-y-1">
                                <div id="firstChef"
                                     className={`flex flex-col text-center p-2 ${game?.turns[0].isChallengeSuccessful ? 'bg-amber-300 animate-pulse' : 'bg-zinc-400'} rounded-lg`}>
                                    {game?.turns[0]?.challenger ? getStars(game?.turns[0]?.challenger.stars) : null}
                                    {game?.turns[0]?.challenger ?
                                        <img className="w-40 max-h-38 rounded-lg"
                                             src={game?.turns[0]?.challenger.image}/>
                                        :
                                        <div
                                            className="fa-solid fa-upload text-brand text-6xl w-40 max-h-40 bg-zinc-200 rounded-lg py-12"/>
                                    }
                                    {getDetails(game?.turns[0]?.gameType, false, game?.turns[0]?.champion, game)}
                                </div>
                                <div id="secondChef"
                                     className={`flex flex-col text-center p-2 ${game?.turns[1].isChallengeSuccessful ? 'bg-amber-300 animate-pulse' : 'bg-zinc-400'} rounded-lg`}>
                                    {game?.turns[1]?.challenger ? getStars(game?.turns[1]?.challenger.stars) : null}
                                    {game?.turns[1]?.challenger ?
                                        <img className="w-40 max-h-38 rounded-lg"
                                             src={game?.turns[1]?.challenger.image}/>
                                        :
                                        <div
                                            className="fa-solid fa-upload text-brand text-6xl w-40 max-h-40 bg-zinc-200 rounded-lg py-12"/>
                                    }
                                    {getDetails(game?.turns[1]?.gameType, false, game?.turns[1]?.champion, game)}
                                </div>
                                <div id="thirdChef"
                                     className={`flex flex-col text-center p-2 ${game?.turns[2].isChallengeSuccessful ? 'bg-amber-300 animate-pulse' : 'bg-zinc-400'} rounded-lg`}>
                                    {game?.turns[2]?.challenger ? getStars(game?.turns[2]?.challenger.stars) : null}
                                    {game?.turns[2]?.challenger ?
                                        <img className="w-40 max-h-38 rounded-lg"
                                             src={game?.turns[2]?.challenger.image}/>
                                        :
                                        <div
                                            className="fa-solid fa-upload text-brand text-6xl w-40 max-h-40 bg-zinc-200 rounded-lg py-12"/>
                                    }
                                    {getDetails(game?.turns[2]?.gameType, false, game?.turns[2]?.champion, game)}
                                </div>
                            </div>
                        </div>
                        <div className="bg-zinc-500 animate-pingee">
                            <div className="text-center h-16">
                                <p className="p-4">
                                    {`You ${game?.payoutWalletPK === playerPK ? 'win' : 'lose'} ${game?.amount} ${game?.isSOL ? '$SOL' : '$CHEF'}`}
                                </p>
                            </div>
                            <p className="pull-right text-xs rounded-lg">Commentary</p>
                        </div>
                    </div>
                </div>
            </div>
            {game?.payoutWalletPK === playerPK ?
                <ReactFloatingBalloons
                    loop={false}
                    hangOnTop={true}
                    count={5}
                    msgText="Pop and win!"
                    colors={["red"]}
                    popVolumeLevel={0.1}
                />
                :
                null}
        </div>
    );
}

export default GameResultsPanel;